import { useState } from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { API } from "@/lib/api";
import { toast } from "sonner";

export default function ExportDialog({ dataset, testid = "export" }) {
  const [open, setOpen] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const download = (fmt) => {
    const token = localStorage.getItem("intenciv_token");
    const params = new URLSearchParams({ fmt });
    if (from) params.append("date_from", from);
    if (to) params.append("date_to", to);
    fetch(`${API}/export/${dataset}?${params.toString()}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Export failed");
        return res.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `intenciv_${dataset}.${fmt}`;
        a.click();
        window.URL.revokeObjectURL(url);
        toast.success(`Exported ${dataset} as ${fmt.toUpperCase()}`);
        setOpen(false);
      })
      .catch(() => toast.error("Export failed"));
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          data-testid={`${testid}-open-button`}
          className="border-[#0a8f8f] text-[#0a8f8f] hover:bg-[#0a8f8f] hover:text-white transition-colors duration-200"
        >
          <Download size={16} className="mr-2" /> Download Data
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-white">
        <DialogHeader>
          <DialogTitle className="font-serif text-navy text-xl">Export {dataset}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-500">
          Select a date range (optional) and format. Exports include a footer with your name and range for audit trail.
        </p>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label className="text-xs">From</Label>
            <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} data-testid="export-date-from" />
          </div>
          <div>
            <Label className="text-xs">To</Label>
            <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} data-testid="export-date-to" />
          </div>
        </div>
        <DialogFooter className="gap-2">
          <Button onClick={() => download("csv")} data-testid="export-csv-button" variant="outline">
            Export CSV
          </Button>
          <Button onClick={() => download("xlsx")} data-testid="export-xlsx-button" style={{ background: "#042C53" }} className="text-white">
            Export Excel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
